import HTMLPlayer from './HTMLPlayer';
import VimeoPlayer from './VimeoPlayer';
import YoutubePlayer from './YoutubePlayer';

const ALLOWED_MEDIA_TYPES = ['mp4', 'vimeo', 'youtube', 'webm'];

const __getPlayer = function (el, key) {
  switch (key) {
    case 'youtube':
      return new YoutubePlayer(el);
    case 'vimeo':
      return new VimeoPlayer(el);
    default:
      return new HTMLPlayer(el);
  }
};

export default {
  beforeMount(el, binding) {
    if (!ALLOWED_MEDIA_TYPES.includes(binding.value)) return;
    let player; let
      playerKey;
    const video = el.querySelector('.media-item');
    new MutationObserver(() => {
      el.dispatchEvent(player.events.loadScript);
    }).observe(video, {
      attributes: true,
      attributeFilter: ['src'],
    });
    el.addEventListener('videoPlayer.ready', () => {
      const playButton = el.querySelector('button');
      el.addEventListener('videoPlayer.play', () => {
        player.play();
        el.classList.add('is-playing');
        el.classList.remove('is-paused');
      });
      el.addEventListener('videoPlayer.stop', () => {
        player.stop();
        el.classList.add('is-paused');
        el.classList.remove('is-playing');
      });
      if (playButton) {
        playButton.addEventListener('click', () => {
          if (el.classList.contains('is-playing')) {
            el.dispatchEvent(player.events.stop);
          } else {
            el.dispatchEvent(player.events.play);
          }
        });
      }
    });

    playerKey = binding.value ? binding.value.toLowerCase() : '';
    player = __getPlayer(el, playerKey);
  },
};
